import * as React from "react";
import { Provider } from "@fluentui/react-northstar/dist/es/components/Provider/Provider";
import { useEffect } from "react";
import { useTeams } from "msteams-react-base-component";
import * as microsoftTeams from "@microsoft/teams-js";

import WebexPresenceIcon from "../../components/Webex/WebexPresenceIcon/WebexPresenceIcon";
import { IWebexPresenceIconProps } from "../../components/Webex/WebexPresenceIcon/IWebexPresenceIconProps";
import { raiseClick } from "office-ui-fabric-react";
import ProxyHealthCheck from "../../components/HealthCheck/ProxyHealthCheck/ProxyHealthCheck";

/**
 * Implementation of the TabDevTest content page (for SBK, FADE)
 */

export const TabDevTest = () => {

    /*  ############################################################
        here is some stuff which you may use or not...
       - to get information if user is in teams-browser or normal browser (not within teams-app)
       - and other stuff (o365-login-info, theme to use, etc.)
    */
    const [{ inTeams, theme, context }] = useTeams();
    const [item, setItem] = React.useState(true);
    const clickItem = () => { console.log(item); setItem(!item); };

    // magic initialization-stuff
    useEffect(() => {
        if (inTeams === true) {
            microsoftTeams.appInitialization.notifySuccess();
        } else {
            // do nothing (just test-scenario)
        }
    }, [inTeams]);

    // check if we do have an o365-teams-context (meaning we are in teams-app and we are possibly logged in)
    useEffect(() => {
        if (context) {
            // do nothing (just test-scenario)
        }
    }, [context]);

    /*  ############################################################
        This is the stuff for html-output.
    */

    const cpbxIntEmailTestAxelS20: string = "axels20@deutschland-lan.de";
    const contextPropsPresenceIconAxelS20: IWebexPresenceIconProps = {
        cpbxIntEmail: cpbxIntEmailTestAxelS20,
        doUpdateStatus: true,
        updateDelayInSec: 10,
        doShowIntEmailInTitle: true,
        doShowDateTimeInTitle: true
    };

    const cpbxIntEmailTestHolgerKuehn: string = "holgerkuehn@deutschland-lan.de";
    const contextPropsPresenceIconHolgerKuehn: IWebexPresenceIconProps = {
        cpbxIntEmail: cpbxIntEmailTestHolgerKuehn,
        doUpdateStatus: false
    };

    const cpbxIntEmailTestThomas01Test02: string = "thomas01.test02@deutschland-lan.de";
    const contextPropsPresenceIconThomas01Test02: IWebexPresenceIconProps = {
        cpbxIntEmail: cpbxIntEmailTestThomas01Test02,
        doUpdateStatus: false
    };

    const myTestOutputAll = (
        <Provider theme={theme}>
            {/* <p>Dev Test for webex-presence-icon for user &apos;{cpbxIntEmailTestAxelS20}&apos;</p>
            {item && <WebexPresenceIcon {...contextPropsPresenceIconAxelS20} /> }
            <button onClick={clickItem}> hide</button>

            <br />
            <p>Dev Test for webex-presence-icon for user &apos;{cpbxIntEmailTestHolgerKuehn}&apos;</p>
            <WebexPresenceIcon {...contextPropsPresenceIconHolgerKuehn} />
            <br />
            <p>Dev Test for webex-presence-icon for user &apos;{cpbxIntEmailTestThomas01Test02}&apos;</p>
            <WebexPresenceIcon {...contextPropsPresenceIconThomas01Test02} /> */}
            <ProxyHealthCheck/>
        </Provider>
    );

    // output all from variable (dynamically)
    return myTestOutputAll;
};
